<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <ECMConfirmDialog ref="confirmationDlg" v-model="confirmationDlg"/>
            <ECMCleanLogsModal v-model="showCleanLogsModal"/> 
            <b-col>
                <h1>{{ecmResourceStrings.ttlECMRepoConfig}}</h1>
                <p>{{ecmResourceStrings.txtECMRepoInfoText}}</p>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <otif-button class=" OTPrimary" @click.native="save" id="OTSaveSetting" :title="ecmResourceStrings.tipECMSaveConfig" style="margin-right:0.5rem" :disabled="$v.$dirty === false || $v.$invalid === true">{{ecmResourceStrings.lblSave}}</otif-button>
                <b-dropdown text="Actions" right class="OTtableRowDropdown">
                    <b-dropdown-item v-for="action in actions" @click="onAction(action)" :key="action.name">
                        <span :class="'ot-icon-' + action.id" />{{ action.label }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <otif-select
            v-bind:label="ecmResourceStrings.lblDriver"
            v-model="$v.form.driver_type.$model"
            :required="false"
            :validation="$v.form.driver_type"
            :values="driver_types"
            @input="changeConnectivity($event)"
            :description="ecmResourceStrings.tipECMDriver"/>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblHostname"
            v-model="$v.form.host_name.$model"
            :validation="$v.form.host_name"
            v-bind:invalidMessage="ecmResourceStrings.msgHostnamerequired"
            :required="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticHostName"/>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblPort"
            v-model="$v.form.ecm_port.$model"
            v-bind:invalidMessage="ecmResourceStrings.msgPortrequired"
            :validation="$v.form.ecm_port"
             @input.native='onchange'
             :description="ecmResourceStrings.tipOticPort"/>
        <otif-checkbox v-if="seen"
            v-model="form.sid"
            v-bind:label="ecmResourceStrings.lblUseSID"
            :required="false"
            :disabled="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipSID"/>
        <otif-textInput v-if="getdrivertype === 'Oracle' && getusesid === true"
            v-bind:label="ecmResourceStrings.lblSID"
            v-model="$v.form.database_name.$model"
            v-bind:invalidMessage="ecmResourceStrings.msgSIDrequired"
            :validation="$v.form.database_name"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticSIDName"/>
        <otif-textInput v-else-if="getdrivertype === 'Oracle' && getusesid === false"
            v-bind:label="ecmResourceStrings.lblServicename"
            v-model="$v.form.database_name.$model"
            v-bind:invalidMessage="ecmResourceStrings.msgServicenamerequired"
            :validation="$v.form.database_name"
            @input.native='onchange'
            :description="ecmResourceStrings.tipOticServiceName"/>
        <otif-textInput v-else
            v-bind:label="ecmResourceStrings.lblDatabasename"
            v-model="$v.form.database_name.$model"
            v-bind:invalidMessage="ecmResourceStrings.msgDatabasenamerequired"
            :validation="$v.form.database_name"
            :value='false'
            @input.native='onchange'
            :description="ecmResourceStrings.tipECMDBName"/>
         <otif-textInput
            v-model="$v.form.repo_connect_params.$model"
            v-bind:label="ecmResourceStrings.lblConnectinformation"
            :validation="$v.form.repo_connect_params"
            :required="false"
            @input.native='onchange'
            :description="ecmResourceStrings.tipConnectInformation"/>
        <otif-textInput
            v-model="$v.form.user.$model"
            v-bind:label="ecmResourceStrings.lblDBuser"
            :validation="$v.form.user"
            v-bind:invalidMessage="ecmResourceStrings.msgDBuserrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipDBUserName"/>
        <otif-passwordInput
            v-model="$v.form.password.$model"
            v-bind:label="ecmResourceStrings.lblDBpassword"
            :validation="$v.form.password"
            v-bind:invalidMessage="ecmResourceStrings.msgDBpasswordrequired"
            @input.native='onchange'
            :description="ecmResourceStrings.tipDBPassword"/>
        </b-col>
    </b-row>
</template>

<script>

import axios from 'axios';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import ECMConfirmDialog from '../../modals/ECMCrawlerConfirmDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { portbounders } from '../../../utils/validatorECM.js';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage} from '../../../utils/commonECM.js';
import { showConfirmationDialog } from '../../../utils/commonECM.js';
import { getCurrentCrawlerRepositoryVersion } from '../../../utils/commonECM.js';
import ECMCleanLogsModal from '../../modals/ECMCrawlerCleanLogs.vue';

const defaultPorts = {
    'SQL':'1433',
    'Oracle': '1521',
    'PostgreSQL':'5432',
};

export default {
    components: {
         ECMErrorDialog,
         ECMConfirmDialog,
         ECMCleanLogsModal,
    },
    mixins: [ validationMixin ],
    data() {
        return {
            showCleanLogsModal: false,
            seen: false,
            loaded: false,
            messageDlg: false,
            confirmationDlg:false,
            fdroprepo:false,
            fdallrepos:false,
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            driver_types: [
                //'SQL',
                //'Oracle',
                'PostgreSQL'
            ],

            form: {
                driver_type: '',
                host_name: '',
                ecm_port: '',
                database_name: '',
                sid:false,
                password:'*****',
                user:'',
                repo_connect_params:'',
            },
            actions: [{
                name: 'test',
                label: 'Test connection',
                callback: this.onTestConnection
            },{
                name: 'create',
                label: 'Create',
                callback: this.onCreate
            },{
                name: 'migrate',
                label: 'Migrate',
                callback: this.onMigrate
            },{
                name: 'verify',
                label: 'Verify',
                callback: this.onVerify
            },{
                name: 'drop',
                label: 'Drop',
                callback: this.askDeleteRepository
            },{
                name: 'export',
                label: 'Export',
                callback: this.onExport
            },{
                name: 'import',
                label: 'Import',
                callback: this.onImport
            },{
                name: 'delete',
                label: 'Delete all ECM and RDBMS repositories',
                callback: () => { this.deleteRepositories(); }
            },{
                name: 'clean',
                label: 'Clean logs',
                callback: this.onClean
            }],
        }
    },

    validations: {
        form: {
            driver_type: { required },
            host_name: { required },
            ecm_port: { required, portbounders, numericval },
            database_name: { required },
            password:{ required },
            user:{ required },
            repo_connect_params:{},
        }
    },

    computed: {
         /* these should be in computed area because if it's in watch area label of controls are not changed*/
        getusesid:function()
        {
            const val =  this.form.sid;
            return val;
        },
        getdrivertype: function ()
        {
            if(this.form.driver_type !== 'Oracle')
            {
                this.form.sid = false;
                this.seen = false;
            }
            else
            {
                this.seen = true;
            }
            const val =  this.form.driver_type;
            return val;
        },
    },

    methods: {
        onchange($e) {
            this.$v.$touch(true);
        },

        changeConnectivity(newVal) {
            this.$v.$touch(true);
            const defaultPort = defaultPorts[newVal];
                      
            if(newVal !== 'Oracle')
            {
                this.form.sid = false;
                this.seen = false;
            }
            else
            {
                this.seen = true;
            }
                        
            this.form.ecm_port = defaultPort;
        },

        onAction(action) {
            if (action.hasOwnProperty('callback')) {
                action.callback(action);
            }
        },

        onTestConnection(){
            /*status of the Crawler Repository Connection access and validates the Crawler Tables existing in this Database
            Validity attempts to run a SELECT statement for ECM repositories that exist in the InfoFusion Crawler for ECM repository.
            If the SELECT statement fails, Verify fails. If data or even no data is returned, Verify succeeds.*/
            /*Test Connection causes InfoFusion Crawler for ECM Services to verify the InfoFusion Crawler 
            ECM database settings to confirm database user credentials and database name. */
            this.$snotify.async(this.ecmResourceStrings.txtEcmStartingTestConnection, {
                timeout: 0
            });

            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/ECMRepositories')
            .then((res) => {
                this.$snotify.clear();
                this.$snotify.success(this.ecmResourceStrings.txtCrawlerRepositoryTested);
                this.$v.$reset();
            })
            .catch((err) => {
                this.showError(err, 'validate');
            });

        },

        onCreate(){
            this.$snotify.async(this.ecmResourceStrings.txtValidateVersion, {
                timeout: 0
            });
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/info/CrawlerECMSchemaVersion')
            .then((res) => {
                if (res.data) {
                    var i = 0;
                    for(i = 0; i < res.data.component.length; i++)
                    {
                        const data = res.data.component[i].name;
                        const n = data.indexOf("Crawler ECM schema version");
                        if(n > -1)
                        {
                            this.fdroprepo = false;
                            const version = res.data.component[i].versionNumber;

                            if(version == 'unknown')
                            {//no repository yet
                                that.$snotify.clear();
                                showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlCreateRepository, that.ecmResourceStrings.txtCreateRepository);
                                break;
                            }
                            else
                            {
                                const curVersion = getCurrentCrawlerRepositoryVersion();
                                if(version < curVersion)
                                {
                                    that.$snotify.clear();
                                    showMessage(this, 'info', that.ecmResourceStrings.ttlCreateRepository,'', true, that.ecmResourceStrings.txtWrongVersion);
                                }
                                else
                                {
                                    that.$snotify.clear();
                                    showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlCreateRepository, that.ecmResourceStrings.txtCreateRepository);
                                    break;
                                }
                            }
                        }
                    }
                    that.loaded = true;
                }
            })
            .catch((err) => {
                that.loaded = true;
                this.showError(err, 'create');
            });
        },

        askDeleteRepository(rowNumber){
            var that = this;
            that.$snotify.clear();
            
            if(rowNumber == -1)
            {
                that.fdallrepos = true;
                showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeleteRepositories, that.ecmResourceStrings.txtDeleteRepositories);
            }
            else
            {
                that.fdroprepo = true;
                showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeleteCrawlerRepo, that.ecmResourceStrings.txtDeleteCrawlerRepository);
            }
        },

        deleteRepositories(){
            var that = this;
            that.askDeleteRepository(-1);
        },

        deleteAllRepositories()
        {
            var that = this;
            that.fdallrepos = false;
            that.$snotify.info(that.ecmResourceStrings.txtStartDeleting);
            axios.delete('/mtm-gateway-api/v1/services/ecm/ECMRepositories')
                .then((res) => {
                        
                        
                        that.$snotify.clear();
                        that.$snotify.success(that.ecmResourceStrings.txtAllDeleteSuccess);
                        
                    })
                    .catch((err) => {
                        that.$snotify.clear();
                        
                        if(err.description)
                        {
                        that.$snotify.error(that.ecmResourceStrings.txtAllDeleteError, {
                            buttons: [
                                {text: that.ecmResourceStrings.txtViewDetails, action:()=>that.$eventBus.$emit('show-error-ecm', that.ecmResourceStrings.txtAllDeleteError, err.message, err.description), bold: true },
                            ],
                        });
                        }
                        else{
                            this.$snotify.error(err.message, that.ecmResourceStrings.txtAllDeleteError);
                        }
                    });     
            
        },


        onMigrate(){
            this.$snotify.async(this.ecmResourceStrings.txtValidateVersion, {
                timeout: 0
            });

            var that = this;

            //check if migrate is available
            axios.get('/mtm-gateway-api/v1/services/ecm/config?fields=CrawlerECMSchemaVersion')
            .then((res) => {
                this.$snotify.clear();
                if (res.status == 200)
                {
                    if (res.data)
                    {
                        var i = 0;
                        for(i = 0; i < res.data.settingDetails.length; i++)
                        {
                            const data = res.data.settingDetails[i].name;
                            if(data == 'CrawlerECMSchemaVersion')
                            {
                                const SourceVersion = res.data.settingDetails[i].value;
                                const TargetVersion = getCurrentCrawlerRepositoryVersion();
                                if(SourceVersion == TargetVersion)
                                {
                                    that.$snotify.success(that.ecmResourceStrings.txtMigrateRepository);
                                }
                                else
                                {
                                    that.migrateCrawlerRepo(SourceVersion,TargetVersion);
                                }
                                break;
                            }
                        }
                    }
                }
            })
            .catch((err) => {
                this.$snotify.clear();
                this.showError(err, 'migrate');
            });
        },

        onVerify(){
            //start process test connection that takes Crawler connection parameters including user name and password 
            //this function will verify if we can get ECM Repository tables and if the
            //version of Crawler repository corresponds to product version
            this.$snotify.async(this.ecmResourceStrings.txtEcmStartingVerify, {
                timeout: 0
            });
           
            var that = this;
            const connString=that.createBodyPostString();

            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryTestConnection', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                /*this means the process run test is started. But we do not know whet the status is
                That is why now we are going to ask about status result*/
                that.getTestConnectionStatus('-101', '-1', true);
            })
            .catch((err) => {
                this.showError(err, 'verify');
            });
       },

       onExport(){
           this.$snotify.async(this.ecmResourceStrings.txtEcmRepoExportStart, {
                timeout: 0
            });
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/ECM')
                .then((res) => {
                    if (res.data) {
                        const data = JSON.stringify(res.data)
                        const blob = new Blob([data], {type: 'text/plain'})
                        const e = document.createEvent('MouseEvents'),
                        a = document.createElement('a');
                        a.download = "ecmcrawlerconfig.json";
                        a.href = window.URL.createObjectURL(blob);
                        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                        a.dispatchEvent(e);
                        this.$snotify.clear();
                 }})
                .catch((err) => {
                    this.showError(err, 'get');
                    this.$snotify.clear();
                    this.$snotify.error(this.ecmResourceStrings.txtEcmRepoExportFail);
                });
           },

       onImport(){
           this.$router.push('/settings/ecmrepository/ecmrepositoryimport');
           return;
        },

        onClean(){
            this.showCleanLogsModal = true;
            return;
        },

        cleanLogs(days){
            var that = this;
            this.$snotify.async(this.ecmResourceStrings.txtEcmStartingClean, {
                timeout: 0
            });
            const parameters = '[{ "name" : "rtNumberDays", "value" : '+ days +', "type" : "int","isNull" : false}]';
            const connString = '{"name": "CleanAllCrawlerLogs", "engineName": "1", "parameters": ' + parameters + ', "asynchronousExecution": true}';

            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data && res.data.crawlerOperationDetails[0]) {
                        setTimeout(that.getProcessStatus(), 20000);
                    }
                })
                .catch((err) => {
                    this.$snotify.clear();
                    if(err.response)
                    {
                        var sTitle=this.ecmResourceStrings.ttlECMCleanLogs;
                        this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, err.response.data), bold: true },
                        ],
                    });
                    }
                    else
                    {
                        this.$snotify.error(err.message);
                    }
            });

        },

        async getProcessStatus()
        {
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess?ProcessName=CleanAllCrawlerLogs')
                .then((res) => {
                    that.$snotify.clear();
                    if (res.data) {
                        if(res.data.crawlerExecuteProcessResultsDetails)
                        {
                            const len = res.data.crawlerExecuteProcessResultsDetails.length;
                            if(res.data.crawlerExecuteProcessResultsDetails[len-1])
                            {
                                if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails)
                                {
                                    const lenDet = res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails.length;
                                    if(lenDet > 0)
                                    {
                                        if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionStatusDetails == null)
                                        {
                                           
                                        }
                                        else
                                        {
                                            if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionStatusDetails.status=="Finished")
                                            {
                                                if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionLogDetails.status == "Error")
                                                {
                                                    if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionExceptionDetails
                                                    && res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionExceptionDetails[0])
                                                    {
                                                       
                                                        const error = res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionExceptionDetails[0].description;
                                                        showMessage(this, 'info', that.ecmResourceStrings.ttlECMCleanLogs, "Error", true, error);
                                                    }
                                                    else
                                                    {
                                                        
                                                    }
                                                  
                                                }
                                                else
                                                {
                                                   
                                                }
                                            }
                                            else if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionStatusDetails.status=="Running")
                                            {
                                                
                                            }
                                            else
                                            {
                                                const logId = res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionLogDetails.logId;
                                                //if(logId > 0)
                                                //    that.getErrors(showmessage, true, logId);
                                            }
                                        }
                                    }
                                }
                                else
                                {
                                    //can not get status
                                    
                                }   
                            }
                            else
                            {
                                //it means method on thin machine is not completed. never should be here, but just in case
                               
                            }
                        }
                        else{
                            //it means method on thin machine is not completed. never should be here, but just in case
                            
                        }
                }
            })
            .catch((err) => {
                this.$snotify.clear();
                //can not get status at all
                showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,err.response.statusText, true, err.response.data);
            });
        },

        getTestConnectionStatus(id, jobid, showmessage)
        {
            var that = this;
             axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryTestConnection/' + id)
            .then((res) => {
                if (res.data) {
                    if(res.data.crawlerOperationDetails)
                    {
                        var operationStatus = '';
                        operationStatus  = res.data.crawlerOperationDetails[0].operationStatus;
                        if(operationStatus === 'Finished')
                        {
                            this.$snotify.clear();
                            var actionStatusMessage = '';
                            if(res.data.crawlerOperationDetails[0].actionStatusMessage != undefined)
                            {
                                actionStatusMessage  = res.data.crawlerOperationDetails[0].actionStatusMessage;
                                if(actionStatusMessage =='' || actionStatusMessage == null)
                                {
                                    if(res.data.crawlerOperationDetails[0].executionComments != undefined)
                                    {
                                        actionStatusMessage  = res.data.crawlerOperationDetails[0].executionComments;
                                    }
                                }
                            }
                            if(actionStatusMessage.length == 0)
                            {
                                if(showmessage == true)
                                {
                                    this.$snotify.success(that.ecmResourceStrings.txtEcmCrawlerRepositoryVerified);
                                }
                            }
                            else
                            {
                                const caption = that.ecmResourceStrings.ttlTestEcmCrawlerConnection;
                                if(showmessage == true)
                                {
                                    showMessage(this, 'info', caption, '', true, actionStatusMessage);
                                }
                            }
                        }
                        else if(operationStatus === 'Error')
                        {
                            this.$snotify.clear();
                            var actionStatusMessage = '';
                            if(res.data.crawlerOperationDetails[0].actionStatusMessage != undefined)
                                {
                                actionStatusMessage  = res.data.crawlerOperationDetails[0].actionStatusMessage;
                                //that.updateStatusClassTest("repository_invalid");
                                if(actionStatusMessage =='' || actionStatusMessage == null)
                                {
                                    if(res.data.crawlerOperationDetails[0].executionComments != undefined)
                                    {
                                        actionStatusMessage  = res.data.crawlerOperationDetails[0].executionComments;
                                    }
                                    //that.updateStatusClassTest("status_noaccess");
                                }
                            }
                            if(actionStatusMessage.length == 0)
                            {
                                actionStatusMessage = that.ecmResourceStrings.txtError;
                            }
                            const caption = that.ecmResourceStrings.ttlTestEcmCrawlerConnection;
                            
                            if(showmessage == true)
                            {   
                                //showMessage(this, 'error', caption, '', true, actionStatusMessage);
                            }
                            this.$snotify.error(caption, operationStatus, {
                            buttons: [
                                {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', caption, operationStatus, true, actionStatusMessage), bold: true },
                            ],
                        });
                        }
                        else
                        {
                            //not completed. Ask about status again
                            that.getTestConnectionStatus(id, jobid);
                        }
                    }
                }
            })
            .catch((err) => {
                this.showError(err, 'validate');
            });
        },

        migrateCrawlerRepo(SourceVersion, TargetVersion){
            var that = this;
            this.$snotify.clear();
            this.$snotify.async(this.ecmResourceStrings.txtEcmStartingMigrate, {
                timeout: 0
            });
           
            const connString=that.createBodyPostString();
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryMigration?EngineName=1&SourceVersion=' +  SourceVersion + '&TargetVersion=' + TargetVersion, connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                this.$snotify.clear();
                this.showResults(res, 'migrate');
                this.$v.$reset();
            })
            .catch((err) => {
                this.$snotify.clear();
                this.showError(err, 'migrate');
            });     
        },

        createRepository()
        {
            var that = this;
            that.$snotify.async(this.ecmResourceStrings.txtStartCreating, {
                timeout: 0
            });

            const connString=that.createBodyPostString();
                
            //we are here doesn't meter if we are doing it's first time or next times.
            //we do not have post statement. Only put
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CreateCrawlerRepository', connString,
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                this.$snotify.clear();
                this.showResults(res, 'create');
                this.$v.$reset();
            })
            .catch((err) => {
                this.showError(err, 'create');
            });
        },

        dropRepository()
        {
            var that = this;
            that.$snotify.async(this.ecmResourceStrings.txtStartDeletingRepo, {
                timeout: 0
            });

            const connString=that.createBodyPostString();

            //we are here doesn't meter if we are doing it's first time or next times.
            //we do not have post statement. Only put
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/DropCrawlerRepository', connString,
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                this.$snotify.clear();
                this.showResults(res, 'drop');
                this.$v.$reset();
            })
            .catch((err) => {
                this.showError(err, 'drop');
            });
        },

        createBodyPostString : function()
        {
            /*{
            "crawlerOperationDetails":[
            {"repositoryId":"",
            "operationType":"Idle",
            "operationMode":"Start",
            "operationStatus":"Idle",
            "engineName":"1",
            "actionStatusCode":"0",
            "actionStatusMessage":"",
            "executionStatusCode":"0",
            "executionFolderPathOrId":"",
            "executionComments":"",
            "jobId":""}]}*/
           
            const configstring = '{"repositoryId": ' + '-101' + ', "operationType": "Idle", "operationMode": "Start", "operationStatus": "Idle", "engineName":"1", "partitionId":"-1", "ecmConnectionId": "-1", "actionStatusCode":"0", "actionStatusMessage":"" , "executionStatusCode":"0", "executionFolderPathOrId":"", "executionComments":"", "jobId":"" }';
            const connString = '{"crawlerOperationDetails":[' + configstring + ']}';
            return connString;
        },

        saveConfirmed()
        {         
            this.confirmationDlg = false;

            if(this.fdallrepos == true)
            {
                this.deleteAllRepositories();
                return;
            }
            if(this.fdroprepo == true)
            {
                this.dropRepository();
            }
            else
            {
                this.createRepository();
            }
        },

        save()
         {
            this.$snotify.async(this.ecmResourceStrings.txtStartSaving);

            //prepare the string for save
            const host_name = this.form.host_name.trim();
            const port_num = this.form.ecm_port.trim();
            const database_name = this.form.database_name.trim();
            const repo_connect_params = this.form.repo_connect_params.trim();
            const user = this.form.user.trim();
            const credo = this.form.password.trim();
            const sid = this.form.sid;
            const driverChoosen = this.form.driver_type.trim();

            //combine url string
            const additionalConn = repo_connect_params;
            const additionalConn1 = additionalConn.trim();
            var additionalConn2 = "";
            if(additionalConn1 != "")
            {
                //check if last is ;
                const stringLength = additionalConn1.length; 
                const lastChar = additionalConn1.charAt(stringLength - 1); // this will be the string "."
                if(lastChar != ";")
                {
                    const additionalConn3 = additionalConn1 + ";";
                    additionalConn2=";"+additionalConn3;
                }
                else
                {
                    additionalConn2=";"+additionalConn1;
                }
            }

            var driver =  "opentext.genio.jdbc.oracle.OracleDriver";
            var connectivity = "Oracle";
            var url='';
            if(driverChoosen == 'Oracle')
            {
                if(port_num != null)
                {
                    if(sid == true)
                    {
                        url = 'jdbc:opentext:oracle://' + host_name + ':' + port_num + ';SID=' +  database_name + additionalConn2;
                    }
                    else
                    {
                        url = 'jdbc:opentext:oracle://' + host_name + ':' + port_num + ';ServiceName=' +  database_name + additionalConn2;
                    }
                }
                else
                {
                    if(sid == true)
                    {
                        url = 'jdbc:opentext:oracle://' + host_name + ';SID=' +  database_name + additionalConn2;
                    }
                    else
                    {
                        url = 'jdbc:opentext:oracle://' + host_name + ';ServiceName=' +  database_name + additionalConn2;
                    }
                }
            }
            else if(driverChoosen == 'SQL')
            {               
                driver =  "opentext.genio.jdbc.sqlserver.SQLServerDriver";
                connectivity = "MSSql";
                if(port_num != null)
                {
                    url= 'jdbc:opentext:sqlserver://' + host_name + ':' + port_num + ';databaseName=' +  database_name + additionalConn2;               
                }
                else
                {
                    url= 'jdbc:opentext:sqlserver://' + host_name + ';databaseName=' +  database_name + additionalConn2;
                }
            }
            else if(driverChoosen == 'PostgreSQL')
            {               
                driver =  "opentext.genio.jdbc.postgresql.PostgreSQLDriver";
                connectivity = "PostgreSQL";
                if(port_num != null)
                {
                    url= 'jdbc:opentext:postgresql://' + host_name + ':' + port_num + ';databaseName=' +  database_name + additionalConn2;              
                }
                else
                {
                    url= 'jdbc:opentext:postgresql://' + host_name + ';databaseName=' +  database_name + additionalConn2;
                }
            }

            var connString = '{"driver": "' + driver + '", "url": "' + url + '", "user": "' + user + '", "connectivity": "'+ connectivity+ '"';

            if(credo != "*****")
                connString = connString + ',"password": "' + credo + '"';

            connString = connString + '}';

            //we are here doesn't meter if we are doing it's first time or next times.
            //we do not have post statement. Only put
            axios.put('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/ECM', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                this.$snotify.clear();
                this.$snotify.success(this.ecmResourceStrings.txtECMConfigSaved);
                this.$v.$reset();
            })
            .catch((err) => {
                this.showError(err, 'save');
            });
        },

        showResults(res, location)
        {
            var sTitle='';
            var sSuccess='';
            if(location === 'migrate')
            {
                sTitle = this.ecmResourceStrings.ttlMigrateRepository;
                sSuccess = this.ecmResourceStrings.txtCrawlerRepositoryMigrated;
            }
            else if(location === 'create')
            {
                sTitle = this.ecmResourceStrings.ttlCreateRepository;
                sSuccess = this.ecmResourceStrings.txtCrawlerRepositoryCreated;
            }
            else if(location === 'drop')
            {
                sTitle = this.ecmResourceStrings.ttlDeleteCrawlerRepo;
                sSuccess = this.ecmResourceStrings.txtCrawlerRepositoryDeleted;
            }
                            
            this.$snotify.clear();
            if(res)
            {
                if(res.data)
                {
                    if(res.data.crawlerOperationDetails)
                    {
                        var actionStatusMessage = '';
                        if(res.data.crawlerOperationDetails[0].actionStatusMessage != undefined)
                        {
                            actionStatusMessage  = res.data.crawlerOperationDetails[0].actionStatusMessage;
                            if(actionStatusMessage =='' || actionStatusMessage == null)
                            {
                                if(res.data.crawlerOperationDetails[0].executionComments != undefined)
                                {
                                    actionStatusMessage  = res.data.crawlerOperationDetails[0].executionComments;
                                }
                            }
                        }
                        if(actionStatusMessage.length == 0)
                        {
                            actionStatusMessage = sSuccess;
                        }
                        showMessage(this, 'success', sTitle, '', true, actionStatusMessage);
                    }
                    else
                    {
                        this.$snotify.success(sSuccess);
                    }
                }
                else
                {
                    this.$snotify.success(sSuccess);
                }
            }
            else
            {
                this.$snotify.success(sSuccess);
            }
        },

        showError(err, location)
        {
            var sTitle='';
            var sError='';
            if(location === 'validate')
            {
                sTitle = this.ecmResourceStrings.ttlTestEcmCrawlerConnection;
                sError = this.ecmResourceStrings.errEcmRepoValidate;
            }
            else if(location === 'save')
            {
                sTitle = this.ecmResourceStrings.ttlEcmSaveConnection;
                sError = this.ecmResourceStrings.errEcmRepoSave;
            }
            else if(location === 'get')
            {
                sTitle = this.ecmResourceStrings.txtError;
                sError = this.ecmResourceStrings.errEcmRepoGet;
            }
            else if(location === 'create')
            {
                sTitle = this.ecmResourceStrings.ttlCreateRepository;
                sError = this.ecmResourceStrings.errEcmRepoCreate;
            }
            else if(location === 'verify')
            {
                sTitle = this.ecmResourceStrings.ttlVerifyEcmRepository;
                sError = this.ecmResourceStrings.errEcmRepoVerify;
            }
            else if(location === 'migrate')
            {
                sTitle = this.ecmResourceStrings.ttlMigrateRepository;
                sError = this.ecmResourceStrings.errEcmRepoMigrate;
            }
            else if(location === 'drop')
            {
                sTitle = this.ecmResourceStrings.ttlDeleteCrawlerRepo;
                sError = this.ecmResourceStrings.errEcmRepoDelete;
            }
                        
            this.$snotify.clear();
            if(err.response)
            {
                if(err.response.data)
                {
                    if(err.response.data.crawlerOperationDetails)
                    {
                        var actionStatusMessage = '';
                        if(err.response.data.crawlerOperationDetails[0].actionStatusMessage)
                        {
                            actionStatusMessage  = err.response.data.crawlerOperationDetails[0].actionStatusMessage;
                            if(actionStatusMessage =='')
                            {
                                if(err.response.data.crawlerOperationDetails[0].executionComments)
                                {
                                    actionStatusMessage  = err.response.data.crawlerOperationDetails[0].executionComments;
                                }
                            }
                        }
                        if(actionStatusMessage.length == 0)
                        {
                            actionStatusMessage = this.ecmResourceStrings.txtCrawlerRepositoryTested;
                        }
                        this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                            buttons: [
                                {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, actionStatusMessage), bold: true },
                            ],
                        });
                    }
                    else
                    {
                        this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                            buttons: [
                                {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, err.response.data), bold: true },
                            ],
                        });
                    }
                }
                else if(err.message)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, err.message), bold: true },
                        ],
                    });
                }
                else
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, false, ''), bold: true },
                        ],
                    });
                }
            }
            else
            {
                this.$snotify.error(sError);
            }
        },
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repo-settings',
            meta: { label: 'Crawling Service' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        axios.get('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/ECM')
        .then((res) => {
            if (res.data) {
                //that.form.password = "*****";
                //we are not care about connectivity
                that.form.user = res.data.user;

                const driver =res.data['driver'];
                const url =res.data['url'];
                var connString="";
                const partsArray = url.split(';');
                const lenArr = partsArray.length;
                var databaseString = "";
                var busesid = false;
                for (var i=1;i<partsArray.length;i++)
                {
                    var c = partsArray[i].trim();
                    if (c.indexOf("databaseName") > -1 || c.indexOf("SID") > -1 || c.indexOf("ServiceName")  > -1 || c.indexOf("DatabaseName") > -1)
                    {
                        databaseString=c;
                        if (c.indexOf("SID") == 0)
                        {
                            busesid = true;
                        }
                    }
                    else
                    {
                        if(c.length > 0)
                        {
                            const strTemp = c+";";
                            connString = connString +strTemp;
                        }
                    }
                }
                const fullDriverName = partsArray[0];
                const tst = fullDriverName.split(':');
                var server = tst[3];
                const dbs = databaseString.split('=');
                const databaseName = dbs[1];
                const port =  tst[4];
                const drs = driver.split('.');
                const serverType = drs[4];
                if(server)
                    server = server.substr(2);
                that.form.ecm_port = port;
                that.form.host_name = server;
                that.form.database_name = databaseName;
                that.form.sid = busesid;
                that.form.repo_connect_params = connString;
                if(serverType == "OracleDriver")
                {
                    that.form.driver_type = 'Oracle';
                }
                else if(serverType == "PostgreSQLDriver")
                {
                    that.form.driver_type = 'PostgreSQL';
                }
                else //sql
                {
                    that.form.driver_type = 'SQL';
                }
                that.loaded = true;
                that.$v.$reset();
            }
        })
        .catch((err) => {
             if(err.response.status == 406)
            {
                this.$snotify.info('Connection to ECM Crawling Service Database was not configured yet.');
            }
            else
            {
                this.showError(err, 'get');
            }
            this.loaded = true;
            this.$v.$reset();
        });
    },
}
</script>